type FilterDictEntry = {
  title: string
  defaultValue: string
  stateFieldName: string
  options?: Array<{ value: string; label: string }>
  beforeField?: string
  afterField?: string
}

type FilterDict = {
  [K in string]: FilterDictEntry
}

const filterDict = {
  parent: {
    title: "Parent Status",
    defaultValue: "",
    stateFieldName: "parent",
    options: [
      { value: "true", label: "Is a Parent" },
      { value: "false", label: "Not a Parent" },
    ],
  },
  grandparent: {
    title: "Grandparent Status",
    defaultValue: "",
    stateFieldName: "grandparent",
    options: [
      { value: "true", label: "Is a Grandparent" },
      { value: "false", label: "Not a Grandparent" },
    ],
  },
  spouse: {
    title: "Spouse Status",
    defaultValue: "",
    stateFieldName: "spouse",
    options: [
      { value: "true", label: "Has a Spouse" },
      { value: "false", label: "Not a Spouse" },
    ],
  },
  partner: {
    title: "Partner Status",
    defaultValue: "",
    stateFieldName: "partner",
    options: [
      { value: "true", label: "Has a Partner" },
      { value: "false", label: "Not a Partner" },
    ],
  },
  sibling: {
    title: "Sibling Status",
    defaultValue: "",
    stateFieldName: "sibling",
    options: [
      { value: "true", label: "Has a Sibling" },
      { value: "false", label: "Not a Sibling" },
    ],
  },
  extendedFamily: {
    title: "Extended Family Status",
    defaultValue: "",
    stateFieldName: "extendedFamily",
    options: [
      { value: "true", label: "Has an Extended Family Member" },
      { value: "false", label: "Not a Extended Family Member" },
    ],
  },
  faculty: {
    title: "Faculty Status",
    defaultValue: "",
    stateFieldName: "faculty",
    options: [
      { value: "true", label: "Is a Faculty member" },
      { value: "false", label: "Not a Faculty member" },
    ],
  },
  member: {
    title: "Member Status",
    defaultValue: "",
    stateFieldName: "member",
    options: [
      { value: "true", label: "Is a Member" },
      { value: "false", label: "Not a Member" },
    ],
  },
  email: {
    title: "Email Status",
    defaultValue: "",
    stateFieldName: "email",
    options: [
      { value: "true", label: "Has Email" },
      { value: "invalidEmail", label: "Has Invalid Email" },
      { value: "false", label: "Has Missing Email" },
    ],
  },
  phoneNumber: {
    title: "Phone Number Status",
    defaultValue: "",
    stateFieldName: "phoneNumber",
    options: [
      { value: "true", label: "Has Phone" },
      { value: "false", label: "Is Missing Phone" },
    ],
  },
  name: {
    title: "Name Status",
    defaultValue: "",
    stateFieldName: "name",
    options: [
      { value: "true", label: "Has Name" },
      { value: "false", label: "Is Missing Name" },
    ],
  },
  career: {
    title: "Career Status",
    defaultValue: "",
    stateFieldName: "career",
    options: [
      { value: "true", label: "Has Career" },
      { value: "false", label: "Is Missing Career" },
    ],
  },
  education: {
    title: "Education Status",
    defaultValue: "",
    stateFieldName: "education",
    options: [
      { value: "true", label: "Has Education" },
      { value: "false", label: "Is Missing Education" },
    ],
  },
  groups: {
    title: "Groups Status",
    defaultValue: "",
    stateFieldName: "groups",
    options: [
      { value: "true", label: "Has Groups" },
      { value: "false", label: "Is Missing Groups" },
    ],
  },
  classYear: {
    title: "Class Year Status",
    defaultValue: "",
    stateFieldName: "classYear",
    options: [
      { value: "true", label: "Has Class Year" },
      { value: "false", label: "Is Missing Class Year" },
    ],
  },
  address: {
    title: "Mailing Address Status",
    defaultValue: "",
    stateFieldName: "address",
    options: [
      { value: "true", label: "Has Mailing Address" },
      { value: "false", label: "Is Missing Mailing Address" },
    ],
  },
  socialProfiles: {
    title: "Social Profiles Status",
    defaultValue: "",
    stateFieldName: "socialProfiles",
    options: [
      { value: "true", label: "Has Social Profiles" },
      { value: "false", label: "Is Missing Social Profiles" },
    ],
  },
  sourcedEmails: {
    title: "Sourced Emails Status",
    defaultValue: "",
    stateFieldName: "sourcedEmails",
    options: [
      { value: "true", label: "Has Sourced Emails" },
      { value: "false", label: "Is Missing Sourced Emails" },
    ],
  },
  admin: {
    title: "Admin Status",
    defaultValue: "",
    stateFieldName: "admin",
    options: [
      { value: "true", label: "Is Admin" },
      { value: "false", label: "Is Not Admin" },
    ],
  },
  profileNotes: {
    title: "Profile Notes Status",
    defaultValue: "",
    stateFieldName: "profileNotes",
    options: [
      { value: "true", label: "Has Profile Notes" },
      { value: "false", label: "Missing Profile Notes" },
    ],
  },
  isBusinessProfile: {
    title: "Business Profile Status",
    defaultValue: "",
    stateFieldName: "isBusinessProfile",
    options: [
      { value: "true", label: "Is Business Profile" },
      { value: "false", label: "Is Not Business Profile" },
    ],
  },
  deceased: {
    title: "Deceased Status",
    defaultValue: "",
    stateFieldName: "deceased",
    options: [
      { value: "true", label: "Is Deceased" },
      { value: "false", label: "Is Not Deceased" },
    ],
  },
  suspended: {
    title: "Suspended Status",
    defaultValue: "",
    stateFieldName: "suspended",
    options: [
      { value: "true", label: "Is Suspended" },
      { value: "false", label: "Is Not Suspended" },
    ],
  },
  shadowBanned: {
    title: "Shadow Banned Status",
    defaultValue: "",
    stateFieldName: "hide_suspended_notification",
    options: [
      { value: "true", label: "Is Shadow Banned" },
      { value: "false", label: "Is Not Shadow Banned" },
    ],
  },
  signedIn: {
    title: "Signed In Status",
    defaultValue: "",
    stateFieldName: "signedIn",
    options: [
      { value: "true", label: "Has Signed In" },
      { value: "false", label: "Has Not Signed In" },
    ],
  },
  donated: {
    title: "Philanthropy Status",
    defaultValue: "",
    stateFieldName: "donated",
    beforeField: "donatedBefore",
    afterField: "donatedAfter",
    options: [
      { value: "true", label: "Has Donated" },
      { value: "false", label: "Has Not Donated" },
    ],
  },
  updated: {
    title: "Updated Status",
    defaultValue: "",
    stateFieldName: "updated",
    beforeField: "updatedBefore",
    afterField: "updatedAfter",
    options: [
      { value: "true", label: "Has Updated" },
      { value: "false", label: "Has Not Updated" },
    ],
  },
  volunteerRoleId: {
    title: "Volunteer Role",
    defaultValue: "",
    stateFieldName: "volunteerRoleId",
    options: [],
  },
  latitude: {
    title: "Latitude",
    defaultValue: "",
    stateFieldName: "latitude",
  },
  longitude: {
    title: "Longitude",
    defaultValue: "",
    stateFieldName: "longitude",
  },
  city: {
    title: "City",
    defaultValue: "",
    stateFieldName: "city",
  },
  stateCode: {
    title: "State Code",
    defaultValue: "",
    stateFieldName: "stateCode",
  },
  minimumDistance: {
    title: "Minimum Distance",
    defaultValue: "",
    stateFieldName: "minimumDistance",
  },
  donatedAfter: {
    title: "Donated After",
    defaultValue: "",
    stateFieldName: "donatedAfter",
  },
  donatedBefore: {
    title: "Donated Before",
    defaultValue: "",
    stateFieldName: "donatedBefore",
  },
  updatedAfter: {
    title: "Updated After",
    defaultValue: "",
    stateFieldName: "updatedAfter",
  },
  updatedBefore: {
    title: "Updated Before",
    defaultValue: "",
    stateFieldName: "updatedBefore",
  },
} satisfies FilterDict

export default filterDict
